





















































































































import _ from "lodash";

import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { Contractor,CognitoUser } from "@/models";

@Component
export default class ContractorDetail extends Vue {
  @Prop({ default: false }) public showsidebar: boolean;

  @Getter("contractors/hasUnsavedChanges") public hasUnsavedChanges: boolean;

  @Getter("contractors/current") public contractors: Contractor;

  @Getter("contractors/list") public contractorslist: Contractor[];

  @Mutation("contractors/setCurrent")
  public setCurrent: (contractors: Contractor) => void;

  @Action("contractors/setContractorsDeep")
  public setContractorsDeep: (payload: {
    path: string;
    data: any;
  }) => Promise<any>;

  @Action("contractors/addContractors")
  public addContractors: (contractors: Contractor) => Promise<any>;
  @Action("sysadmin/getUserByUsername")
  public getUserByUsername: (userName: string) => Promise<CognitoUser>;
  @Action("contractors/updateContractors")
  public updateContractors: (contractors: Contractor) => Promise<any>;

  public mounted() {
    if (this.isNewContractors()) {
      this.setCurrent(new Contractor());
    }
  }

  get addressLine1() {
    return this.contractors.address.line1;
  }
  set addressLine1(data) {
    this.setContractorsDeep({ path: "address.line1", data });
  }

  get addressLine2() {
    return this.contractors.address.line2;
  }
  set addressLine2(data) {
    this.setContractorsDeep({ path: "address.line2", data });
  }

  get addressTown() {
    return this.contractors.address.town;
  }
  set addressTown(data) {
    this.setContractorsDeep({ path: "address.town", data });
  }

  get addressCounty() {
    return this.contractors.address.county;
  }
  set addressCounty(data) {
    this.setContractorsDeep({ path: "address.county", data });
  }

  get addressPostcode() {
    return this.contractors.address.postcode;
  }
  set addressPostcode(data) {
    this.setContractorsDeep({ path: "address.postcode", data });
  }

  get companyName() {
    return this.contractors.companyName;
  }
  set companyName(data) {
    this.setContractorsDeep({ path: "companyName", data });
  }

  get email() {
    return this.contractors.email;
  }
  set email(data) {
    this.setContractorsDeep({ path: "email", data });
  }

  get phone() {
    return this.contractors.phone;
  }
  set phone(data) {
    this.setContractorsDeep({ path: "phone", data });
  }

  public canAdd() {
    let result = true;
    if (!this.addressLine1 || !this.addressTown || !this.addressPostcode || !this.email || !this.phone)
      result = false;
    return result;
  }

  public canSave() {
    let result = true;
    if (!this.addressLine1 || !this.addressTown || !this.addressPostcode || !this.email || !this.phone)
      result = false;
    return result;
  }

  public isNewContractors() {
    return this.$router.currentRoute.params.id == "new";
  }

  public isSaving: boolean = false;
  public async saveAll() {
    if (this.isNewContractors()) {
      this.isSaving = true;
      let cognitoUser = await this.getUserByUsername(this.email);
      if (cognitoUser != null && cognitoUser.Username != '') {
        this.isSaving = false;
        this.$toasted.error("User Already Exist");
        return;
      } else {
        this.addContractors(this.contractors).then(() => {
        this.isSaving = false;
        this.$toasted.success("Added");
        this.$router.push("/contractors");
      });
      }
     
    } else {
      this.isSaving = true;
      this.updateContractors(this.contractors).then(() => {
        this.isSaving = false;
        this.$toasted.success("Saved");
        this.$router.push("/contractors");
      });
    }
  }

  public cancel() {
    this.setCurrent(new Contractor());
    this.$router.push("/contractors");
  }
}
